module.exports = __webpack_public_path__ + "img/collar height.413018d7.png";